import React, { useState, useEffect, useCallback } from 'react';
import { useForm, FormProvider, get } from 'react-hook-form';
import makeStyles from '@mui/styles/makeStyles';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Paper from '@mui/material/Paper';
import Checkbox from '@mui/material/Checkbox';
import Stack from '@mui/material/Stack';
import Select from '@mui/material/Select';
import {UnsafeHTML} from './UnsafeHTML';
import MenuItem from '@mui/material/MenuItem';
import Box from '@mui/material/Box';
import { Link } from 'react-router-dom';
import { handleResponse } from '../services/HandleResponse';

import { FormControlLabel, FormHelperText, LinearProgress, Typography } from '@mui/material';
import {Form} from "./Form"
import { useAuth } from './AuthProvider';
import { ActivateCaptcha } from './ActivateCaptcha';

//import { authenticationService } from '../services/AuthenticationService';


const useStyles = makeStyles((theme)=>({
    root: {
        maxWidth: 500
    },
    margin: {
        //margin: theme.spacing(2)
    }
}));

export const Register = ({ returnTo, ...props }) => {
    const formContext = useForm({ shouldUnregister: true });
    const { formState: { errors }, register } = formContext;

    const [generalLoginError, setGeneralLoginError] = useState('');
    //const { enqueueSnackbar } = useSnackbar();
    //const [isLoggedIn, setLoggedIn] = useState(false);
    //const { setUser } = useContext(UserContext);
    //const { setAuthToken } = useContext(AuthContext);
    const classes = useStyles();
    const [resetInfo, setResetInfo] = useState({});
   // const [resetType, setResetType] = useState(null);
    const [loading, setLoading] = useState(false);
    const [config, setConfig] = useState({});
    const [refresh, setRefresh] = useState(0);
    const [auth] = useAuth();

    useEffect(()=>{
        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
        };

        fetch(`/anywhere/api/users/register`, requestOptions)
        .then(handleResponse)
        .then(info => {
            setConfig(info);
            setGeneralLoginError(null);
            setLoading(false);
            return info;
        },
        error => {
            console.log(JSON.stringify(error));
            setLoading(false);
            setGeneralLoginError(error?.message||error||"Config error");
            setRefresh((i)=>i+1);
        }
        );
    },[]);

   
    const onSubmitLogin = useCallback((data, token, event) => {
        
        var sendData =  {...resetInfo, ...data, recaptchaToken: token};
        if(data.captcha)
        sendData.captcha = data.captcha;

        if(data.password1!=null && data.password==null)
        {
            if(data.password1 !== data.password2)
            {
            setLoading(false);
            setGeneralLoginError("The passwords must match");
            return;
            }
            sendData.password = data.password1;
        }
    
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(sendData)
        };

        return fetch(`/anywhere/api/users/register`, requestOptions)
            .then(handleResponse)
            .then(info => {
                setResetInfo(info);
                setGeneralLoginError(null);
                setLoading(false);
                return info;
            },
            error => {
                console.log(JSON.stringify(error));
                setLoading(false);
                setGeneralLoginError(error?.message||error||"Login Error");
                setRefresh((i)=>i+1);
            }
            );

    }, [resetInfo, setResetInfo, setGeneralLoginError, setLoading]);

  
      var toSet = resetInfo?.questions?.numberToSet?[...Array(resetInfo?.questions?.numberToSet).keys()]:[];
    var showContinue = ((resetInfo.status === 'UserConfirm' && generalLoginError) || resetInfo.status === 'UserCreated');

    return (
        <FormProvider {...formContext}>
        <Form title="Register" setLoading={setLoading} onSubmit={(data, token, event) => onSubmitLogin(data, token, event)}>      
         <Grid item xs={12}>
            {!resetInfo.userName &&
            <Stack sx={{gap:1}}>
                   {config.instructions && <Typography variant="caption"><UnsafeHTML html={config.instructions}></UnsafeHTML></Typography>}

                    <TextField
                        id="firstName"
                        variant="standard"
                        {...register("firstName", { required: "Please enter your first name" })}
                        className={classes.margin}
                        fullWidth
                        helperText={errors?.firstName ? errors.firstName.message : null}
                        label="First Name"
                        error={errors?.firstName!=null}
                    />
                    <TextField
                    id="lastName"
                    variant="standard"
                    {...register("lastName", { required: "Please enter your last name" })}
                    className={classes.margin}
                    fullWidth
                    helperText={errors?.lastName ? errors.lastName.message : null}
                    label="Last Name"
                    error={errors?.lastName!=null}
                />
                <TextField
                id="title"
                variant="standard"
                {...register("title", { required: "Please enter your title" })}
                className={classes.margin}
                fullWidth
                helperText={errors?.title ? errors.title.message : null}
                label="Title"
                error={errors?.title!=null}
                />
                <TextField
                id="userName"
                variant="standard"
                {...register("userName", { required: "Please enter your email address" })}
                className={classes.margin}
                fullWidth
                helperText={errors?.userName ? errors.userName.message : null}
                label="Email Address"
                error={errors?.userName!=null}
                />
              
                <TextField
                variant="standard"
                id="password1"
                {...register("password1", { required: "Please enter a password", minLength: {value: config?.minLength, message: "Your password must be at least " + config?.minLength + " characters."} })}
                className={classes.margin}
                fullWidth
                type="password"
                autoComplete="current-password"
                helperText={errors?.password1 ? errors.password1.message : null}
                label="Password"
                error={errors?.password1!=null}
            />
            <TextField
                id="password2"
                variant="standard"
                {...register("password2", { required: "Please enter a password" })}
                className={classes.margin}
                fullWidth
                type="password"
                autoComplete="current-password"
                helperText={errors?.password2 ? errors.password2.message : null}
                label="Confirm Password"
                error={errors?.password2!=null}
            />
            {config.passwordRules && <Typography variant="caption"><UnsafeHTML html={config.passwordRules}></UnsafeHTML></Typography>}
            <ActivateCaptcha key={refresh}></ActivateCaptcha>
                    <TextField
                                    id="captcha"
                                    variant="standard"
                                    className={classes.margin} fullWidth
                                    {...register("captcha", { required: "This value is required." })}
                                    helperText={errors?.captcha ? errors.captcha.message : null}
                                    label={auth.config?.captchaLabel}
                                    error={errors?.captcha}
                                />
            </Stack>
            }
              {resetInfo.status==='UserPin' &&
              <Stack>
                <Typography>Please enter the pin number sent to your email address:</Typography>
                    <TextField
                    id="pin"
                    variant="standard"
                    {...register("pin", { required: "Pin Number" })}
                    className={classes.margin}
                    fullWidth
                    helperText={errors?.pin ? errors.pin.message : null}
                    label="Pin"
                    error={errors?.pin}
              />
               <Typography sx={{mt:2}}>Terms and Conditions</Typography>
               
                <Paper sx={{maxHeight: 200,  overflow: "scroll"}}>
                    <UnsafeHTML html= {resetInfo.terms}/>
                
                    </Paper>
                    <FormControlLabel control={<Checkbox {...register("termsAccepted", { required: "The Terms and Conditions must be accepted." })}/>} label="I Accept the above Terms and Conditions" />
                    {errors?.termsAccepted && <FormHelperText error={errors?.termsAccepted}>{errors?.termsAccepted.message}</FormHelperText>}
                    </Stack>
                  
                }
                {resetInfo.status==='UserRegisterPassword' && resetInfo.questions && toSet && 
                 toSet.map((e, i)=>{
                    var qid = i.toString();
                    var qname= "answers." + i.toString();
                    const qerror = errors?get(errors, qname+".a"):null;
                    return (
                        <Box sx={{mt: 4}}>
                            <Select id={qid + ".id"} 
                                fullWidth={true} 
                                name={qname + ".id"} 
                                width="500px" 
                                {...register(qname+'.id')} 
                                defaultValue={resetInfo.questions.questions[i].id}>
                                {resetInfo.questions.questions.map((child) => {
                                            var v = child.id;
                                            var t = child.text;
                                        
                                        return (<MenuItem key={v} value={v}>{t}</MenuItem >);
                                    }
                                )}
                            </Select>
                            <div className='formControl'>
                            <TextField id={qid+'.text'} autoComplete='off' variant="standard"
                                 {...register(qname+'.text', {minLength: { value: resetInfo.questions.minAnswerSize, message: 'The answers must be more than ' + resetInfo.questions.minAnswerSize + ' characters.' }, required: 'Please enter an answer'})} 
                                 error={qerror != null} helperText={qerror?.message} required={true}
                                 fullWidth={true}
                                />
                                </div>
                        </Box>
        
                    );
                })
                  
                }
                {resetInfo.status==="UserConfirm" &&
                    <Stack sx={{minHeight: 200}}>
                        <UnsafeHTML html= {resetInfo.confirmText}/>
                   </Stack>
                }
              
                {resetInfo.status === 'UserCreated' && <div>
                    <Typography>{resetInfo.confirmText}</Typography>
                    </div>}
            </Grid>
            {loading && <Grid item xs={12}>
                <LinearProgress></LinearProgress>
            </Grid>}
            <Grid item xs={12}>
                {generalLoginError && <FormHelperText error={true}> {generalLoginError}</FormHelperText> }
            </Grid>
                    <Grid item container xs={12} justifyContent="flex-end">
                    <Button component={Link}  color="primary" to="/"  >
                            Cancel
                            </Button>
                    {!showContinue &&
                     <Button variant="contained" color="primary" type="submit" >
                            {resetInfo.status==='UserConfirm'?"Register":"Next"}
                            </Button>}
                    {showContinue &&
                        <Button  component={Link} variant="contained" color="primary" to="/"  >
                            Continue
                            </Button>}
                    
                    </Grid>

                    {
                <div>
                {/*resetInfo?.status*/}
                </div>
                }
      
        </Form>
    </FormProvider>
    );
};